import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import './audio-player.scss'
import { ReactComponent as Deleteicon } from '@/assets/steam/delete-red.svg';

const AudioPlayer: VFC<{
    audioUrl?: string;
    isView?: boolean;
    removeFile:()=>void;
}> = ({ audioUrl , removeFile, isView = false}) => {


    return (
        <div className='audio-player'>
            
            <ReactAudioPlayer
                src={audioUrl}
                autoPlay={false}
                controls
            />
             {!isView && <Deleteicon onClick={() => { removeFile() }} />}
        </div>
    );
};

export default AudioPlayer;
